'use client';

import { useLayoutEffect } from 'react';

import {
  overlayStack,
  type OverlayStackProps,
} from '@/app/components/overlays/core/overlayStack';

interface useScrollLockProps extends OverlayStackProps {
  enabled: boolean;
}

export const useScrollLock = ({
  overlayKey,
  instanceId,
  enabled,
  lockScroll = true,
}: useScrollLockProps) => {
  useLayoutEffect(() => {
    const entry = { overlayKey, instanceId, lockScroll };

    if (enabled) {
      overlayStack.open(entry);
    } else {
      overlayStack.close({ overlayKey, instanceId });
    }

    return () => {
      overlayStack.close({ overlayKey, instanceId });
    };
  }, [overlayKey, instanceId, enabled, lockScroll]);
};
